import { normalizeLevel } from './levelSchema';

/** Loads the campaign levels bundled at build time under public/seed-levels/. */
export async function loadSeedLevels() {
  const manifestRes = await fetch(`${process.env.PUBLIC_URL}/seed-levels/manifest.json`);
  if (!manifestRes.ok) throw new Error('Không đọc được seed-levels/manifest.json.');
  const manifest = await manifestRes.json();

  const levels = [];
  for (const entry of manifest.levels) {
    const fileName = entry.assetPath.split('/').pop();
    const res = await fetch(`${process.env.PUBLIC_URL}/seed-levels/${fileName}`);
    if (!res.ok) throw new Error(`Không đọc được seed-levels/${fileName}.`);
    const json = await res.json();
    json.chapter = entry.chapter;
    levels.push(normalizeLevel(json));
  }
  return levels.sort((a, b) => a.levelId - b.levelId);
}
